/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './app/routes/__root'
import { Route as UsersRouteImport } from './app/routes/users'
import { Route as UpgradeRequestsRouteImport } from './app/routes/upgrade-requests'
import { Route as TeamsRouteImport } from './app/routes/teams'
import { Route as SubscriptionsRouteImport } from './app/routes/subscriptions'
import { Route as PlansRouteImport } from './app/routes/plans'
import { Route as MetricsRouteImport } from './app/routes/metrics'
import { Route as ManagedKeysRouteImport } from './app/routes/managed-keys'
import { Route as LoginRouteImport } from './app/routes/login'
import { Route as FlagsRouteImport } from './app/routes/flags'
import { Route as ErrorsRouteImport } from './app/routes/errors'
import { Route as EmailsRouteImport } from './app/routes/emails'
import { Route as CouponsRouteImport } from './app/routes/coupons'
import { Route as AuditRouteImport } from './app/routes/audit'
import { Route as IndexRouteImport } from './app/routes/index'
import { Route as UsersIndexRouteImport } from './app/routes/users.index'
import { Route as UpgradeRequestsIndexRouteImport } from './app/routes/upgrade-requests.index'
import { Route as TeamsIndexRouteImport } from './app/routes/teams.index'
import { Route as SubscriptionsIndexRouteImport } from './app/routes/subscriptions.index'
import { Route as PlansIndexRouteImport } from './app/routes/plans.index'
import { Route as CouponsIndexRouteImport } from './app/routes/coupons.index'
import { Route as UsersIdRouteImport } from './app/routes/users.$id'
import { Route as TeamsIdRouteImport } from './app/routes/teams.$id'
import { Route as SubscriptionsGrantRouteImport } from './app/routes/subscriptions.grant'
import { Route as SubscriptionsIdRouteImport } from './app/routes/subscriptions.$id'
import { Route as PlansCodeRouteImport } from './app/routes/plans.$code'
import { Route as CouponsIdRouteImport } from './app/routes/coupons.$id'

const UsersRoute = UsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => rootRouteImport,
} as any)
const UpgradeRequestsRoute = UpgradeRequestsRouteImport.update({
  id: '/upgrade-requests',
  path: '/upgrade-requests',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamsRoute = TeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => rootRouteImport,
} as any)
const SubscriptionsRoute = SubscriptionsRouteImport.update({
  id: '/subscriptions',
  path: '/subscriptions',
  getParentRoute: () => rootRouteImport,
} as any)
const PlansRoute = PlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => rootRouteImport,
} as any)
const MetricsRoute = MetricsRouteImport.update({
  id: '/metrics',
  path: '/metrics',
  getParentRoute: () => rootRouteImport,
} as any)
const ManagedKeysRoute = ManagedKeysRouteImport.update({
  id: '/managed-keys',
  path: '/managed-keys',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const FlagsRoute = FlagsRouteImport.update({
  id: '/flags',
  path: '/flags',
  getParentRoute: () => rootRouteImport,
} as any)
const ErrorsRoute = ErrorsRouteImport.update({
  id: '/errors',
  path: '/errors',
  getParentRoute: () => rootRouteImport,
} as any)
const EmailsRoute = EmailsRouteImport.update({
  id: '/emails',
  path: '/emails',
  getParentRoute: () => rootRouteImport,
} as any)
const CouponsRoute = CouponsRouteImport.update({
  id: '/coupons',
  path: '/coupons',
  getParentRoute: () => rootRouteImport,
} as any)
const AuditRoute = AuditRouteImport.update({
  id: '/audit',
  path: '/audit',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UsersRoute,
} as any)
const UpgradeRequestsIndexRoute = UpgradeRequestsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => UpgradeRequestsRoute,
} as any)
const TeamsIndexRoute = TeamsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => TeamsRoute,
} as any)
const SubscriptionsIndexRoute = SubscriptionsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SubscriptionsRoute,
} as any)
const PlansIndexRoute = PlansIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PlansRoute,
} as any)
const CouponsIndexRoute = CouponsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CouponsRoute,
} as any)
const UsersIdRoute = UsersIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => UsersRoute,
} as any)
const TeamsIdRoute = TeamsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => TeamsRoute,
} as any)
const SubscriptionsGrantRoute = SubscriptionsGrantRouteImport.update({
  id: '/grant',
  path: '/grant',
  getParentRoute: () => SubscriptionsRoute,
} as any)
const SubscriptionsIdRoute = SubscriptionsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => SubscriptionsRoute,
} as any)
const PlansCodeRoute = PlansCodeRouteImport.update({
  id: '/$code',
  path: '/$code',
  getParentRoute: () => PlansRoute,
} as any)
const CouponsIdRoute = CouponsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CouponsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/coupons': typeof CouponsRouteWithChildren
  '/emails': typeof EmailsRoute
  '/errors': typeof ErrorsRoute
  '/flags': typeof FlagsRoute
  '/login': typeof LoginRoute
  '/managed-keys': typeof ManagedKeysRoute
  '/metrics': typeof MetricsRoute
  '/plans': typeof PlansRouteWithChildren
  '/subscriptions': typeof SubscriptionsRouteWithChildren
  '/teams': typeof TeamsRouteWithChildren
  '/upgrade-requests': typeof UpgradeRequestsRouteWithChildren
  '/users': typeof UsersRouteWithChildren
  '/coupons/$id': typeof CouponsIdRoute
  '/plans/$code': typeof PlansCodeRoute
  '/subscriptions/$id': typeof SubscriptionsIdRoute
  '/subscriptions/grant': typeof SubscriptionsGrantRoute
  '/teams/$id': typeof TeamsIdRoute
  '/users/$id': typeof UsersIdRoute
  '/coupons/': typeof CouponsIndexRoute
  '/plans/': typeof PlansIndexRoute
  '/subscriptions/': typeof SubscriptionsIndexRoute
  '/teams/': typeof TeamsIndexRoute
  '/upgrade-requests/': typeof UpgradeRequestsIndexRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/emails': typeof EmailsRoute
  '/errors': typeof ErrorsRoute
  '/flags': typeof FlagsRoute
  '/login': typeof LoginRoute
  '/managed-keys': typeof ManagedKeysRoute
  '/metrics': typeof MetricsRoute
  '/coupons/$id': typeof CouponsIdRoute
  '/plans/$code': typeof PlansCodeRoute
  '/subscriptions/$id': typeof SubscriptionsIdRoute
  '/subscriptions/grant': typeof SubscriptionsGrantRoute
  '/teams/$id': typeof TeamsIdRoute
  '/users/$id': typeof UsersIdRoute
  '/coupons': typeof CouponsIndexRoute
  '/plans': typeof PlansIndexRoute
  '/subscriptions': typeof SubscriptionsIndexRoute
  '/teams': typeof TeamsIndexRoute
  '/upgrade-requests': typeof UpgradeRequestsIndexRoute
  '/users': typeof UsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/audit': typeof AuditRoute
  '/coupons': typeof CouponsRouteWithChildren
  '/emails': typeof EmailsRoute
  '/errors': typeof ErrorsRoute
  '/flags': typeof FlagsRoute
  '/login': typeof LoginRoute
  '/managed-keys': typeof ManagedKeysRoute
  '/metrics': typeof MetricsRoute
  '/plans': typeof PlansRouteWithChildren
  '/subscriptions': typeof SubscriptionsRouteWithChildren
  '/teams': typeof TeamsRouteWithChildren
  '/upgrade-requests': typeof UpgradeRequestsRouteWithChildren
  '/users': typeof UsersRouteWithChildren
  '/coupons/$id': typeof CouponsIdRoute
  '/plans/$code': typeof PlansCodeRoute
  '/subscriptions/$id': typeof SubscriptionsIdRoute
  '/subscriptions/grant': typeof SubscriptionsGrantRoute
  '/teams/$id': typeof TeamsIdRoute
  '/users/$id': typeof UsersIdRoute
  '/coupons/': typeof CouponsIndexRoute
  '/plans/': typeof PlansIndexRoute
  '/subscriptions/': typeof SubscriptionsIndexRoute
  '/teams/': typeof TeamsIndexRoute
  '/upgrade-requests/': typeof UpgradeRequestsIndexRoute
  '/users/': typeof UsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/audit'
    | '/coupons'
    | '/emails'
    | '/errors'
    | '/flags'
    | '/login'
    | '/managed-keys'
    | '/metrics'
    | '/plans'
    | '/subscriptions'
    | '/teams'
    | '/upgrade-requests'
    | '/users'
    | '/coupons/$id'
    | '/plans/$code'
    | '/subscriptions/$id'
    | '/subscriptions/grant'
    | '/teams/$id'
    | '/users/$id'
    | '/coupons/'
    | '/plans/'
    | '/subscriptions/'
    | '/teams/'
    | '/upgrade-requests/'
    | '/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/audit'
    | '/emails'
    | '/errors'
    | '/flags'
    | '/login'
    | '/managed-keys'
    | '/metrics'
    | '/coupons/$id'
    | '/plans/$code'
    | '/subscriptions/$id'
    | '/subscriptions/grant'
    | '/teams/$id'
    | '/users/$id'
    | '/coupons'
    | '/plans'
    | '/subscriptions'
    | '/teams'
    | '/upgrade-requests'
    | '/users'
  id:
    | '__root__'
    | '/'
    | '/audit'
    | '/coupons'
    | '/emails'
    | '/errors'
    | '/flags'
    | '/login'
    | '/managed-keys'
    | '/metrics'
    | '/plans'
    | '/subscriptions'
    | '/teams'
    | '/upgrade-requests'
    | '/users'
    | '/coupons/$id'
    | '/plans/$code'
    | '/subscriptions/$id'
    | '/subscriptions/grant'
    | '/teams/$id'
    | '/users/$id'
    | '/coupons/'
    | '/plans/'
    | '/subscriptions/'
    | '/teams/'
    | '/upgrade-requests/'
    | '/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuditRoute: typeof AuditRoute
  CouponsRoute: typeof CouponsRouteWithChildren
  EmailsRoute: typeof EmailsRoute
  ErrorsRoute: typeof ErrorsRoute
  FlagsRoute: typeof FlagsRoute
  LoginRoute: typeof LoginRoute
  ManagedKeysRoute: typeof ManagedKeysRoute
  MetricsRoute: typeof MetricsRoute
  PlansRoute: typeof PlansRouteWithChildren
  SubscriptionsRoute: typeof SubscriptionsRouteWithChildren
  TeamsRoute: typeof TeamsRouteWithChildren
  UpgradeRequestsRoute: typeof UpgradeRequestsRouteWithChildren
  UsersRoute: typeof UsersRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/users': {
      id: '/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/upgrade-requests': {
      id: '/upgrade-requests'
      path: '/upgrade-requests'
      fullPath: '/upgrade-requests'
      preLoaderRoute: typeof UpgradeRequestsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/teams': {
      id: '/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof TeamsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/subscriptions': {
      id: '/subscriptions'
      path: '/subscriptions'
      fullPath: '/subscriptions'
      preLoaderRoute: typeof SubscriptionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plans': {
      id: '/plans'
      path: '/plans'
      fullPath: '/plans'
      preLoaderRoute: typeof PlansRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/metrics': {
      id: '/metrics'
      path: '/metrics'
      fullPath: '/metrics'
      preLoaderRoute: typeof MetricsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/managed-keys': {
      id: '/managed-keys'
      path: '/managed-keys'
      fullPath: '/managed-keys'
      preLoaderRoute: typeof ManagedKeysRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/flags': {
      id: '/flags'
      path: '/flags'
      fullPath: '/flags'
      preLoaderRoute: typeof FlagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/errors': {
      id: '/errors'
      path: '/errors'
      fullPath: '/errors'
      preLoaderRoute: typeof ErrorsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emails': {
      id: '/emails'
      path: '/emails'
      fullPath: '/emails'
      preLoaderRoute: typeof EmailsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/coupons': {
      id: '/coupons'
      path: '/coupons'
      fullPath: '/coupons'
      preLoaderRoute: typeof CouponsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/audit': {
      id: '/audit'
      path: '/audit'
      fullPath: '/audit'
      preLoaderRoute: typeof AuditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof UsersRoute
    }
    '/upgrade-requests/': {
      id: '/upgrade-requests/'
      path: '/'
      fullPath: '/upgrade-requests/'
      preLoaderRoute: typeof UpgradeRequestsIndexRouteImport
      parentRoute: typeof UpgradeRequestsRoute
    }
    '/teams/': {
      id: '/teams/'
      path: '/'
      fullPath: '/teams/'
      preLoaderRoute: typeof TeamsIndexRouteImport
      parentRoute: typeof TeamsRoute
    }
    '/subscriptions/': {
      id: '/subscriptions/'
      path: '/'
      fullPath: '/subscriptions/'
      preLoaderRoute: typeof SubscriptionsIndexRouteImport
      parentRoute: typeof SubscriptionsRoute
    }
    '/plans/': {
      id: '/plans/'
      path: '/'
      fullPath: '/plans/'
      preLoaderRoute: typeof PlansIndexRouteImport
      parentRoute: typeof PlansRoute
    }
    '/coupons/': {
      id: '/coupons/'
      path: '/'
      fullPath: '/coupons/'
      preLoaderRoute: typeof CouponsIndexRouteImport
      parentRoute: typeof CouponsRoute
    }
    '/users/$id': {
      id: '/users/$id'
      path: '/$id'
      fullPath: '/users/$id'
      preLoaderRoute: typeof UsersIdRouteImport
      parentRoute: typeof UsersRoute
    }
    '/teams/$id': {
      id: '/teams/$id'
      path: '/$id'
      fullPath: '/teams/$id'
      preLoaderRoute: typeof TeamsIdRouteImport
      parentRoute: typeof TeamsRoute
    }
    '/subscriptions/grant': {
      id: '/subscriptions/grant'
      path: '/grant'
      fullPath: '/subscriptions/grant'
      preLoaderRoute: typeof SubscriptionsGrantRouteImport
      parentRoute: typeof SubscriptionsRoute
    }
    '/subscriptions/$id': {
      id: '/subscriptions/$id'
      path: '/$id'
      fullPath: '/subscriptions/$id'
      preLoaderRoute: typeof SubscriptionsIdRouteImport
      parentRoute: typeof SubscriptionsRoute
    }
    '/plans/$code': {
      id: '/plans/$code'
      path: '/$code'
      fullPath: '/plans/$code'
      preLoaderRoute: typeof PlansCodeRouteImport
      parentRoute: typeof PlansRoute
    }
    '/coupons/$id': {
      id: '/coupons/$id'
      path: '/$id'
      fullPath: '/coupons/$id'
      preLoaderRoute: typeof CouponsIdRouteImport
      parentRoute: typeof CouponsRoute
    }
  }
}

interface CouponsRouteChildren {
  CouponsIdRoute: typeof CouponsIdRoute
  CouponsIndexRoute: typeof CouponsIndexRoute
}

const CouponsRouteChildren: CouponsRouteChildren = {
  CouponsIdRoute: CouponsIdRoute,
  CouponsIndexRoute: CouponsIndexRoute,
}

const CouponsRouteWithChildren =
  CouponsRoute._addFileChildren(CouponsRouteChildren)

interface PlansRouteChildren {
  PlansCodeRoute: typeof PlansCodeRoute
  PlansIndexRoute: typeof PlansIndexRoute
}

const PlansRouteChildren: PlansRouteChildren = {
  PlansCodeRoute: PlansCodeRoute,
  PlansIndexRoute: PlansIndexRoute,
}

const PlansRouteWithChildren = PlansRoute._addFileChildren(PlansRouteChildren)

interface SubscriptionsRouteChildren {
  SubscriptionsIdRoute: typeof SubscriptionsIdRoute
  SubscriptionsGrantRoute: typeof SubscriptionsGrantRoute
  SubscriptionsIndexRoute: typeof SubscriptionsIndexRoute
}

const SubscriptionsRouteChildren: SubscriptionsRouteChildren = {
  SubscriptionsIdRoute: SubscriptionsIdRoute,
  SubscriptionsGrantRoute: SubscriptionsGrantRoute,
  SubscriptionsIndexRoute: SubscriptionsIndexRoute,
}

const SubscriptionsRouteWithChildren = SubscriptionsRoute._addFileChildren(
  SubscriptionsRouteChildren,
)

interface TeamsRouteChildren {
  TeamsIdRoute: typeof TeamsIdRoute
  TeamsIndexRoute: typeof TeamsIndexRoute
}

const TeamsRouteChildren: TeamsRouteChildren = {
  TeamsIdRoute: TeamsIdRoute,
  TeamsIndexRoute: TeamsIndexRoute,
}

const TeamsRouteWithChildren = TeamsRoute._addFileChildren(TeamsRouteChildren)

interface UpgradeRequestsRouteChildren {
  UpgradeRequestsIndexRoute: typeof UpgradeRequestsIndexRoute
}

const UpgradeRequestsRouteChildren: UpgradeRequestsRouteChildren = {
  UpgradeRequestsIndexRoute: UpgradeRequestsIndexRoute,
}

const UpgradeRequestsRouteWithChildren = UpgradeRequestsRoute._addFileChildren(
  UpgradeRequestsRouteChildren,
)

interface UsersRouteChildren {
  UsersIdRoute: typeof UsersIdRoute
  UsersIndexRoute: typeof UsersIndexRoute
}

const UsersRouteChildren: UsersRouteChildren = {
  UsersIdRoute: UsersIdRoute,
  UsersIndexRoute: UsersIndexRoute,
}

const UsersRouteWithChildren = UsersRoute._addFileChildren(UsersRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuditRoute: AuditRoute,
  CouponsRoute: CouponsRouteWithChildren,
  EmailsRoute: EmailsRoute,
  ErrorsRoute: ErrorsRoute,
  FlagsRoute: FlagsRoute,
  LoginRoute: LoginRoute,
  ManagedKeysRoute: ManagedKeysRoute,
  MetricsRoute: MetricsRoute,
  PlansRoute: PlansRouteWithChildren,
  SubscriptionsRoute: SubscriptionsRouteWithChildren,
  TeamsRoute: TeamsRouteWithChildren,
  UpgradeRequestsRoute: UpgradeRequestsRouteWithChildren,
  UsersRoute: UsersRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
